import React from 'react';
import './Chapters.scss';

function Chapter1() {
  return (
    <section className="chapter">
      <p className="chapter__paragraph firstPg">
        As the sun rises over Perfection Fresh’s Two Wells farm in South Australia, the light
        catches the unique swirl of colors of the company’s Kumato<sup>®</sup> tomatoes ripening on
        the vine. The deep, rich tones of green and purple are just starting to give way to a deep
        brownish red, a sign that they’re ready to be harvested and begin their journey to
        destinations scattered across the continent. This sprawling glasshouse facility is the
        largest of its kind in the Southern Hemisphere, and within its 43 hectares grows an almost
        unfathomable number of tomatoes and cucumbers.
      </p>
      <p className="chapter__paragraph">
        As its name implies, the story of Perfection Fresh is one of an age-old business embracing
        the 21st century with cutting-edge technology to consistently deliver perfect produce. But
        to effectively forecast, grow, and distribute these and many other varieties of produce at
        scale, Perfection Fresh, Australia’s largest privately owned fresh produce business, must
        overcome innumerable variables that impact time, natural resources, and climate.
      </p>
      <p className="chapter__paragraph">And the only way to do it is through data.</p>
    </section>
  );
}

export default Chapter1;
